import { FC, useState } from 'react'

import { PickupDeliveryLocationResponseV1 } from '@forto-dev/customer-master-data-models'
import {
  Cluster,
  IconButton,
  LocationIcon,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Stack,
  Typography,
} from '@forto-dev/phoenix-ui-core'

import { LocationSearchOptionTooltip } from './LocationSearchOptionTooltip'

type LocationSearchOptionProps = {
  option: PickupDeliveryLocationResponseV1
  selected: boolean
}

export const LocationSearchOption: FC<LocationSearchOptionProps> = (props) => {
  const { option, selected } = props
  const selectedColor = selected ? 'primary' : 'default'
  const [isInfoVisible, setIsInfoVisible] = useState(false)

  return (
    <Cluster gap={8} y="center" fullWidth>
      <LocationIcon color={selectedColor} />
      <Stack gap={2} fullWidth>
        <Typography variant="body" color={selectedColor}>
          {option.locationName}
        </Typography>
        <Typography variant="small" color="muted">
          {option.addressFormatted}
        </Typography>
        <Typography variant="small" color="muted">
          {!!option.localAddress && option.localAddressFormatted}
        </Typography>
      </Stack>
      <Popover open={isInfoVisible} onOpenChange={setIsInfoVisible}>
        <PopoverTrigger>
          <IconButton
            label="Info"
            icon="InfoCircle"
            onMouseEnter={() => setIsInfoVisible(true)}
            onMouseLeave={() => setIsInfoVisible(false)}
          />
        </PopoverTrigger>
        <PopoverContent
          onMouseEnter={() => setIsInfoVisible(true)}
          onMouseLeave={() => setIsInfoVisible(false)}
          onClick={(e) => e.stopPropagation()}
        >
          <LocationSearchOptionTooltip option={option} />
        </PopoverContent>
      </Popover>
    </Cluster>
  )
}
